import { Collapse } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CardProduct from '../../../../components/card/CardProduct/CardProduct';
import ButtonSecondaryMedium from '../../../../components/common/ButtonSecondary/ButtonSecondaryMedium';
import LeftMenuDesign from '../../../../components/common/LeftMenuDesign/LeftMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import { DesignerPageContext } from '../../DesignerPage';
import './LeftDoorDesignMenu.scss';
import callApi from '../../../../utils/api/callAPI';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import Chip from '../../../../components/common/Chip/Chip';
import {
  // fetchDoorHandles,
  fetchGroupDoor,
} from '../../../../store/actions/door.handle.action';
const { Panel } = Collapse;

const LeftDoorDesignMenu = ({ open, onDragStart, title }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { products } = useSelector(state => state.product);

  const { setOpenRightDoorAccessoryDesignMenu, groupDoorId, setGroupDoorId } =
    useContext(DesignerPageContext);

  const [currentProduct, setCurrentProduct] = useState();
  const [openSearch, setOpenSearch] = useState(false);
  const [listTypeProduct, setListTypeProduct] = useState([]);
  // const [door, setDoor] = useState([]);

  const [loading, setLoading] = useState(false);

  const { type } = useParams();

  const { door, groupDoor } = useSelector(state => state.doorAndHandle);

  useEffect(() => {
    if (groupDoor.isNeedReloadData) {
      dispatch(fetchGroupDoor());
    }
  }, [groupDoor.isNeedReloadData]);

  useEffect(() => {
    if (groupDoor.data?.length) {
      setGroupDoorId(groupDoor.data[0].value);
    }
  }, [groupDoor.data]);

  useEffect(() => {
    const product = products.data?.find(item => item.type_design === type);
    if (product) {
      const listTypeProduct = product.types
        ?.filter(item => item.code !== null)
        .map(item => ({
          key: item.id,
          label: item.name,
        }));
      if (listTypeProduct.length) {
        setListTypeProduct([...listTypeProduct]);
        setCurrentProduct(listTypeProduct[0].key);
      }
    }
  }, [type, products]);

  // // Fetch data trực tiếp bằng API call
  // useEffect(() => {
  //   if (!currentProduct || !groupDoorId) return;

  //   // const fetchData = async () => {
  //   //   try {
  //   //     setLoading(true);
  //   //     const response = await callApi({
  //   //       endpoint: `modules/v3/door-and-handles`,
  //   //       method: 'get',
  //   //       params: { product_type: currentProduct, door_type: 'HINGED' },
  //   //     });

  //   //     setDoor(response?.data?.result ?? {});
  //   //   } catch (error) {
  //   //     console.error('Error fetching doors:', error);
  //   //     setDoor({});
  //   //   } finally {
  //   //     setLoading(false);
  //   //   }
  //   // };

  //   // fetchData();

  //   dispatch(
  //     fetchDoorHandles({
  //       product_type: currentProduct,
  //       door_type: 'HINGED',
  //       group_type: groupDoorId,
  //     })
  //   );
  // }, [currentProduct, groupDoorId]);

  return (
    <LeftMenuDesign
      open={open}
      classNames={{
        root: '!left-[60px] relative',
        content: '!p-0 gap-0 left-door-design-menu overflow-hidden',
      }}
      header={
        <>
          <span className="text-title-large text-nowrap">{t('Door')}</span>
        </>
      }
      content={
        <>
          <div className="flex items-center justify-start self-stretch relative top-0 left-0 right-0 px-16 py-8 bg-fills-white">
            <div className="flex items-start gap-8 self-stretch">
              {groupDoor.data?.map(item => (
                <Chip
                  label={
                    <span className="text-label-medium-emphasized">
                      {item.label}
                    </span>
                  }
                  active={item.value === groupDoorId}
                  onClick={() => setGroupDoorId(item.value)}
                />
              ))}
            </div>
          </div>
          <div className="flex flex-col p-8 gap-8 self-stretch items-start align-content-start grow overflow-auto">
            <Collapse
              expandIcon={({ isActive }) => (
                <span className="w-16 h-16 flex">
                  {isActive ? <Icon.ICExpandMore /> : <Icon.ICExpandLess />}
                </span>
              )}
              defaultActiveKey={['1', '2', '3']}
              onChange={() => {}}
              className="grow overflow-auto flex self-stretch"
              items={[
                {
                  key: '1',
                  label: (
                    <span className="text-title-medium">
                      {t('With handle')}
                    </span>
                  ),
                  children: (
                    <div className="grid grid-cols-2 !p-0 items-start align-content-start gap-2 grow self-stretch">
                      {door?.data?.door_with_handle?.map((md, i) => {
                        // {listDoor.map((md, i) => {
                        const name = getValueFromString(md.name);
                        const description = getValueFromString(
                          md.description ?? ''
                        );

                        return (
                          <CardProduct
                            key={i}
                            md={md}
                            title={name}
                            description1={description}
                            description2={md.size}
                            moduleType={i}
                            onDragStart={onDragStart}
                          />
                        );
                      })}
                    </div>
                  ),
                },
                {
                  key: '2',
                  label: (
                    <span className="text-title-medium">
                      {t('Without handle')}
                    </span>
                  ),
                  children: (
                    <div className="grid grid-cols-2 !p-0 items-start align-content-start gap-2 grow self-stretch">
                      {door?.data?.door_without_handle?.map((md, i) => {
                        // {listDoor45.map((md, i) => {
                        const name = getValueFromString(md.name);
                        const description = getValueFromString(
                          md.description ?? ''
                        );

                        return (
                          <CardProduct
                            key={i}
                            md={md}
                            title={name}
                            description1={description}
                            description2={md.size}
                            moduleType={i}
                            onDragStart={onDragStart}
                          />
                        );
                      })}
                    </div>
                  ),
                },
              ].map(item => ({
                ...item,
                onKeyDown: e => {
                  e.stopPropagation();
                },
              }))}
            />
          </div>
          <div className="flex items-center justify-center self-stretch relative bottom-0 left-0 right-0 py-16 bg-fills-white">
            <ButtonSecondaryMedium
              title={t('Door accessories')}
              preIcon={<Icon.ICNavigateRight />}
              onClick={() => setOpenRightDoorAccessoryDesignMenu(prev => !prev)}
            />
          </div>
        </>
      }
    />
  );
};

export default LeftDoorDesignMenu;

// import { Collapse } from 'antd';
// import { useContext, useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import CardProduct from '../../../../components/card/CardProduct/CardProduct';
// import ButtonSecondaryMedium from '../../../../components/common/ButtonSecondary/ButtonSecondaryMedium';
// import LeftMenuDesign from '../../../../components/common/LeftMenuDesign/LeftMenuDesign';
// import { Icon } from '../../../../components/icon/icon';
// import { DesignerPageContext } from '../../DesignerPage';
// import './LeftDoorDesignMenu.scss';
// import callApi from '../../../../utils/api/callAPI';
// import { useParams } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';
// import { getValueFromString } from '../../../../utils/data/getValue.utils';
// const { Panel } = Collapse;

// const LeftDoorDesignMenu = ({ open, onDragStart, title }) => {
//   const dispatch = useDispatch();
//   const { t } = useTranslation();

//   const { products } = useSelector(state => state.product);

//   const { setOpenRightDoorAccessoryDesignMenu } =
//     useContext(DesignerPageContext);

//   const [currentProduct, setCurrentProduct] = useState();
//   const [openSearch, setOpenSearch] = useState(false);
//   const [listTypeProduct, setListTypeProduct] = useState([]);
//   const [door, setDoor] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const { type } = useParams();

//   useEffect(() => {
//     const product = products.data?.find(item => item.type_design === type);
//     if (product) {
//       const listTypeProduct = product.types
//         ?.filter(item => item.code !== null)
//         .map(item => ({
//           key: item.id,
//           label: item.name,
//         }));
//       if (listTypeProduct.length) {
//         setListTypeProduct([...listTypeProduct]);
//         setCurrentProduct(listTypeProduct[0].key);
//       }
//     }
//   }, [type, products]);

//   // Fetch data trực tiếp bằng API call
//   useEffect(() => {
//     if (!currentProduct) return;

//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const response = await callApi({
//           endpoint: `modules/v3/door-and-handles`,
//           method: 'get',
//           params: { product_type: currentProduct, door_type: 'HINGED' },
//         });

//         setDoor(response?.data?.result ?? {});
//       } catch (error) {
//         console.error('Error fetching doors:', error);
//         setDoor({});
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [currentProduct]);

//   return (
//     <LeftMenuDesign
//       open={open}
//       classNames={{
//         root: '!left-[60px] relative',
//         content: '!p-0 gap-0 left-door-design-menu overflow-hidden',
//       }}
//       header={
//         <>
//           <span className="text-title-large text-nowrap">{t('Door')}</span>
//         </>
//       }
//       content={
//         <>
//           <div className="flex flex-col p-8 gap-8 self-stretch items-start align-content-start grow overflow-auto">
//             <Collapse
//               expandIcon={({ isActive }) => (
//                 <span className="w-16 h-16 flex">
//                   {isActive ? <Icon.ICExpandMore /> : <Icon.ICExpandLess />}
//                 </span>
//               )}
//               defaultActiveKey={['1', '2', '3']}
//               onChange={() => {}}
//               className="grow overflow-auto flex self-stretch"
//               items={[
//                 {
//                   key: '1',
//                   label: (
//                     <span className="text-title-medium">
//                       {t('With handle')}
//                     </span>
//                   ),
//                   children: (
//                     <div className="flex !p-0 items-start align-content-start gap-2 grow self-stretch flex-wrap">
//                       {door?.data?.door_with_handle?.map((md, i) => {
//                         // {listDoor.map((md, i) => {
//                         const name = getValueFromString(md.name);
//                         const description = getValueFromString(
//                           md.description ?? ''
//                         );

//                         return (
//                           <CardProduct
//                             key={i}
//                             md={md}
//                             title={name}
//                             description1={description}
//                             description2={md.size}
//                             moduleType={i}
//                             onDragStart={onDragStart}
//                           />
//                         );
//                       })}
//                     </div>
//                   ),
//                 },
//                 {
//                   key: '2',
//                   label: (
//                     <span className="text-title-medium">
//                       {t('Without handle')}
//                     </span>
//                   ),
//                   children: (
//                     <div className="flex !p-0 items-start align-content-start gap-2 grow self-stretch flex-wrap">
//                       {door?.data?.door_without_handle?.map((md, i) => {
//                         // {listDoor45.map((md, i) => {
//                         const name = getValueFromString(md.name);
//                         const description = getValueFromString(
//                           md.description ?? ''
//                         );

//                         return (
//                           <CardProduct
//                             key={i}
//                             md={md}
//                             title={name}
//                             description1={description}
//                             description2={md.size}
//                             moduleType={i}
//                             onDragStart={onDragStart}
//                           />
//                         );
//                       })}
//                     </div>
//                   ),
//                 },
//               ].map(item => ({
//                 ...item,
//                 onKeyDown: e => {
//                   e.stopPropagation();
//                 },
//               }))}
//             />
//           </div>
//           <div className="flex items-center justify-center self-stretch relative bottom-0 left-0 right-0 py-[16px] bg-fills-white">
//             <ButtonSecondaryMedium
//               title={t('Door accessories')}
//               preIcon={<Icon.ICNavigateRight />}
//               onClick={() => setOpenRightDoorAccessoryDesignMenu(prev => !prev)}
//             />
//           </div>
//         </>
//       }
//     />
//   );
// };

// export default LeftDoorDesignMenu;
